import React, { useState, useEffect, useRef } from 'react';

const PrivacyContent: React.FC = () => {
  const [language, setLanguage] = useState<'en' | 'de'>(() => {
    const savedLang = localStorage.getItem('privacy-language');
    return (savedLang as 'en' | 'de') || 'en';
  });
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleLanguageChange = (lang: 'en' | 'de') => {
    if (isMounted.current) {
      setLanguage(lang);
      localStorage.setItem('privacy-language', lang);
    }
  };

  return (
    <div className="space-y-8">
      {/* Language Toggle Buttons */}
      <div className="flex justify-end space-x-4 mb-4">
        <button
          onClick={() => handleLanguageChange('en')}
          className={`px-4 py-2 rounded ${language === 'en' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
        >
          English
        </button>
        <button
          onClick={() => handleLanguageChange('de')}
          className={`px-4 py-2 rounded ${language === 'de' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
        >
          Deutsch
        </button>
      </div>

      {language === 'en' ? (
        <div className="prose prose-lg max-w-none">
          <h1>Privacy Policy</h1>
          <section>
            <h2>1. Data protection at a glance</h2>
            <h3>General information</h3>
            <p>
              The following information provides a simple overview of what happens to your personal data when you visit this website.
              happens when you visit this website. Personal data is all data with which you can be
              can be personally identified. For detailed information on the subject of data protection
              our privacy policy listed below this text.
            </p>

            <h3>Data collection on this website</h3>
            <h4>Who is responsible for data collection on this website?</h4>
            <p>
              Data processing on this website is carried out by the website operator. Their contact details
              can be found in the section "Information on the controller" in this privacy policy.
            </p>

            <h4>How do we collect your data?</h4>
            <p>
              On the one hand, your data is collected when you provide it to us. This may, for example, be
              data that you enter in a contact form.
            </p>
            <p>
              Other data is collected automatically or with your consent by our IT systems when you visit the website.
              collected. This is primarily technical data (e.g. internet browser, operating system or time of the
              of the page view). This data is collected automatically as soon as you enter this website.
            </p>

            <h4>What do we use your data for?</h4>
            <p>
              Some of the data is collected to ensure that the website is provided without errors. Other
              data can be used to analyze your user behavior. If contracts can be concluded or initiated via the website
              can be concluded or initiated via the website, the data transmitted will also be processed for contract offers
              orders or other order inquiries.
            </p>

            <h4>What rights do you have regarding your data?</h4>
            <p>
              You have the right to receive information free of charge at any time about the origin, recipient and purpose of your
              stored personal data. You also have the right to request the rectification or
              deletion of this data. If you have given your consent to data processing,
              you can revoke this consent at any time for the future. You also have the right, under
              to request the restriction of the processing of your personal data under certain circumstances.
              You also have the right to lodge a complaint with the competent supervisory authority.
            </p>
            <p>
              You can contact us at any time if you have any further questions on the subject of data protection.
            </p>

            <h4>Analysis tools and tools from third-party providers</h4>
            <p>
              BWhen you visit this website, your surfing behavior may be statistically evaluated. 
              This is mainly done mainly with so-called analysis programs.
            </p>
            <p>
              Detailed information on these analysis programs can be found in the following privacy policy.
            </p>
          </section>

          <section>
            <h2>2. Hosting</h2>
            <h3>External hosting</h3>
            <p>
              This website is hosted externally. The personal data that is collected on this website
              are stored on the servers of the hoster(s). This may primarily involve IP addresses,
              contact requests, meta and communication data, contract data, contact details, names, website accesses and other data
              and other data generated via a website.
            </p>
            <p>
              External hosting is carried out for the purpose of fulfilling the contract with our potential and existing
              existing customers (Art. 6 para. 1 lit. b GDPR) and in the interest of a secure, fast and efficient provision of our online
              provision of our online offer by a professional provider (Art. 6 para. 1 lit. f GDPR).
            </p>
            <p>
              If a corresponding consent has been requested, the processing is carried out exclusively on the basis of
              on the basis of Art. 6 para. 1 lit. a GDPR and § 25 para. 1 TDDDG, insofar as the consent allows the storage of
              of cookies or access to information in the user's end device (e.g. device fingerprinting) within the meaning of the
              within the meaning of the TDDDG. Consent can be revoked at any time.
            </p>
            <p>
              Our host(s) will only process your data to the extent that this is necessary to fulfill its performance
              performance obligations and follow our instructions with regard to this data.
            </p>
            <p>
              We use the following hoting service:<br />
              Netlify Inc.<br />
              Inc., 44 Montgomery Street, Suite 300<br />
              San Francisco, California 94104,<br />
              USA (hereinafter "Netlify")
            </p>

            <h4>Order processing</h4>
            <p>
              We have concluded a data processing agreement (DPA) for the use of the above-mentioned service.
              concluded. This is a contract prescribed by data protection law, which
              guarantees that it will only process the personal data of our website visitors in accordance with our
              instructions and in compliance with the GDPR.
            </p>
          </section>

          <section>
            <h2>3. General notes and mandatory information</h2>
            <h3>Data protection</h3>
            <p>
              The operators of these pages take the protection of your personal data very seriously. We treat your
              personal data confidentially and in accordance with the statutory data protection regulations and
              this privacy policy.
            </p>
            <p>
              When you use this website, various personal data is collected.
              Personal data is data that can be used to identify you personally. This
              privacy policy explains what data we collect and what we use it for. It also explains how
              and for what purpose this is done.
            </p>
            <p>
              We would like to point out that data transmission over the Internet (e.g. when communicating by e-mail)
              can have security gaps. Complete protection of data against access by third parties is not
              possible.
            </p>

            <h3>Note on the responsible body</h3>
            <p>
              The controller responsible for data processing on this website is:
            </p>
            <p>
              Simon Stürzenhofecker<br />
              Birkenstrasse 1<br />
              91249 Weigendorf<br />
              Deutschland
            </p>
            <p>
              Phone: +49 (0) 176 24938417<br />
              Email: info@simons-marketing-solutions.com
            </p>
            <p>
              The controller is the natural or legal person who alone or jointly with others determines 
              the purposes and means of the processing of personal data (e.g. names, e-mail addresses, etc.). decides.
            </p>

            <h3>Storage period</h3>
            <p>
              Unless a more specific storage period has been specified in this privacy policy, your personal data will remain
              your personal data will remain with us until the purpose for data processing no longer applies. If you make a
              legitimate request for deletion or revoke your consent to data processing,
              your data will be deleted, unless we have other legally permissible reasons for storing your personal data
              personal data (e.g. retention periods under tax or commercial law); in the latter
              the latter case, the deletion will take place after these reasons no longer apply.
            </p>

            <h3>General information on the legal basis for data processing on this website</h3>
            <p>
              If you have consented to data processing, we process your personal data on the basis of
              basis of Art. 6 para. 1 lit. a GDPR or Art. 9 para. 2 lit. a GDPR, insofar as special categories of data are processed
              are processed in accordance with Art. 9 para. 1 GDPR. In the event of express consent to the transfer of
              of personal data to third countries, the data processing is also carried out on the basis of Art.
              49 para. 1 lit. a GDPR. If you consent to the storage of cookies or access to information in
              your end device (e.g. via device fingerprinting), the data processing is also carried out
              on the basis of § 25 para. 1 TDDDG. Consent can be revoked at any time. If your data is required for
              contract fulfillment or for the implementation of pre-contractual measures, we process your data on the basis of
              data on the basis of Art. 6 para. 1 lit. b GDPR. Furthermore, we process your data if it is
              
              are required to fulfill a legal obligation on the basis of Art. 6 para. 1 lit. c GDPR.
              Data processing may also be based on our legitimate interest in accordance with Art. 6 para. 1 lit. f
              GDPR. Information on the relevant legal bases in each individual case is provided in the following
              paragraphs of this privacy policy.
            </p>

            <h3>Recipients of personal data</h3>
            <p>
              As part of our business activities, we work together with various external bodies. This
              sometimes requires the transfer of personal data to these external bodies.
              We only pass on personal data to external bodies if this is necessary in the context of
              fulfillment of a contract, if we are legally obliged to do so (e.g. transfer of data to tax authorities)
              to tax authorities), if we have a legitimate interest in the transfer in accordance with Art. 6 para. 1 lit. f GDPR
              or if another legal basis permits the transfer of data. When using
              processors, we only pass on personal data of our customers on the basis of a valid
              contract on order processing. In the case of joint processing, a contract for
              joint processing is concluded.
            </p>

            <h3>Withdrawal of your consent to data processing</h3>
            <p>
              Many data processing operations are only possible with your express consent. You can
              revoke consent you have already given at any time. The legality of the data processing carried out until the revocation
              processing remains unaffected by the revocation.
            </p>

            <h3>Right to object to the collection of data in special cases and to direct marketing (Art. 21 GDPR)</h3>
            <p>
              IF THE DATA PROCESSING IS BASED ON ART. 6 ABS. 1 LIT. E OR F GDPR
              YOU HAVE THE RIGHT TO OBJECT AT ANY TIME, ON GROUNDS RELATING TO YOUR PARTICULAR
              SITUATION, TO OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA; THIS ALSO APPLIES
              PERSONAL DATA; THIS ALSO APPLIES TO PROFILING BASED ON THESE PROVISIONS.
              PROFILING. THE RESPECTIVE LEGAL BASIS ON WHICH PROCESSING IS BASED,
              CAN BE FOUND IN THIS PRIVACY POLICY. IF YOU OBJECT,
              WE WILL NO LONGER PROCESS YOUR PERSONAL DATA CONCERNED UNLESS WE CAN DEMONSTRATE COMPELLING
              UNLESS WE CAN DEMONSTRATE COMPELLING LEGITIMATE GROUNDS FOR THE PROCESSING WHICH OVERRIDE
              THAT OUTWEIGH YOUR INTERESTS, RIGHTS AND FREEDOMS, OR THE PROCESSING SERVES THE
              PROCESSING SERVES THE ASSERTION, EXERCISE OR DEFENSE OF LEGAL CLAIMS
              LEGAL CLAIMS (OBJECTION PURSUANT TO ART. 21 PARA. 1 GDPR).
            </p>
            <p>
              IF YOUR PERSONAL DATA IS PROCESSED FOR THE PURPOSE OF DIRECT MARKETING,
              YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF PERSONAL DATA CONCERNING YOU
              PERSONAL DATA CONCERNING YOU FOR THE PURPOSE OF SUCH ADVERTISING.
              ADVERTISING; THIS ALSO APPLIES TO PROFILING TO THE EXTENT THAT IT IS RELATED TO SUCH DIRECT
              CONNECTION WITH SUCH DIRECT ADVERTISING. IF YOU OBJECT, YOUR PERSONAL DATA WILL SUBSEQUENTLY NO LONGER BE
              SUBSEQUENTLY NO LONGER USED FOR THE PURPOSE OF DIRECT MARKETING (OBJECTION
              IN ACCORDANCE WITH ART. 21 ABS. 2 GDPR).
            </p>

            <h3>Right to lodge a complaint with the competent supervisory authority</h3>
            <p>
              In the event of violations of the GDPR, data subjects have the right to lodge a complaint with a
              supervisory authority, in particular in the Member State of their habitual residence, place of work
              or the place of the alleged infringement. The right to lodge a complaint is without prejudice to other
              administrative or judicial remedies.
            </p>

            <h3>Right to data portability</h3>
            <p>
              You have the right to have data that we process automatically on the basis of your consent or in fulfillment of a contract
              automatically to yourself or to a third party in a commonly used, machine-readable format.
              to be handed over. If you request the direct transfer of the data to another controller
              controller, this will only be done insofar as it is technically feasible.
            </p>

            <h3>Information, correction and deletion</h3>
            <p>
              Within the framework of the applicable legal provisions, you have the right to obtain information free of charge at any time
              information about your stored personal data, its origin and recipients and the purpose of data
              purpose of the data processing and, if applicable, a right to rectification or erasure of this data. For this and
              You can contact us at any time if you have further questions on the subject of personal data.
            </p>

            <h3>Right to restriction of processing</h3>
            <p>
              You have the right to request the restriction of the processing of your personal data.
              You can contact us at any time to do this. The right to restriction of processing exists in
              the following cases:
            </p>
            <ul>
              <li>
                If you dispute the accuracy of your personal data stored by us, we usually need time to verify this.
                time to check this. For the duration of the review, you have the right to
                request the restriction of the processing of your personal data.

              </li>
              <li>
                If the processing of your personal data has occurred/is occurring unlawfully, you can
                request the restriction of data processing instead of erasure.
              </li>
              <li>
                If we no longer need your personal data, but you need it for the exercise, 
                defense or assertion of legal claims, you have the right to object,
                defense or assertion of legal claims, you have the right to request the restriction of the processing of your
                request the restriction of the processing of your personal data instead of erasure.
              </li>
              <li>
                If you have lodged an objection pursuant to Art. 21 para. 1 GDPR, a balance must be struck between
                your interests and our interests. As long as it is not yet clear whose interests prevail, 
                you have the right to request the restriction of the processing of your personal data.
              </li>
            </ul>
            <p>
              If you have restricted the processing of your personal data, this data - apart from its
              data - apart from its storage - only with your consent or for the establishment, exercise or defense of
              defense of legal claims or for the protection of the rights of another natural or legal person
              legal person or for reasons of important public interest of the European Union or of a Member State.
              of a Member State.
            </p>

            <h3>SSL or TLS encryption</h3>
            <p>
              This site uses SSL or TLS encryption for security reasons and to protect the transmission of confidential content, such as
              such as orders or inquiries that you send to us as the site operator, SSL or TLS encryption.
              You can recognize an encrypted connection by the fact that the address line of the browser changes from
              "http://" to "https://" and by the lock symbol in your browser line.
            </p>
            <p>
              If SSL or TLS encryption is activated, the data you transmit to us cannot be read by third parties.
            </p>

            <h3>Objection to advertising e-mails</h3>
            <p>
              The use of contact data published in the context of the imprint obligation for the transmission of
              advertising and information material that has not been expressly requested. The
              The operators of this website expressly reserve the right to take legal action in the event of unsolicited
              advertising information, such as spam e-mails.
            </p>
          </section>

          <section>
            <h2>4. Data collection on this website</h2>
            <h3>Cookies</h3>
            <p>
             Our Internet pages use so-called “cookies”. Cookies are small data packets and do not harm your
              do no damage to your end device. They are either stored temporarily for the duration of a session
              (session cookies) or permanently (permanent cookies) on your end device. Session cookies
              are automatically deleted at the end of your visit. Permanent cookies remain stored on your end device
              until you delete them yourself or they are automatically deleted by your web browser.
            </p>
            <p>
              Cookies may originate from us (first-party cookies) or from third-party companies (third-party cookies).
              cookies). Third-party cookies enable the integration of certain services from third-party companies
              third-party companies within websites (e.g. cookies for processing payment services).
            </p>
            <p>
              Cookies have various functions. Many cookies are technically necessary, as certain website
              website functions would not work without them (e.g. the shopping cart function or the display of videos).
              of videos). Other cookies can be used to evaluate user behavior or for advertising purposes.
              be used.
            </p>
            <p>
              Cookies that are required to carry out the electronic communication process, to provide certain
              functions you require (e.g. for the shopping cart function) or to optimize the website (e.g. cookies to measure the web
              website (e.g. cookies for measuring the web audience) (necessary cookies) are stored on the basis of
              stored on the basis of Art. 6 para. 1 lit. f GDPR, unless another legal basis is specified.
              The website operator has a legitimate interest in the storage of necessary cookies for the technically
              technically error-free and optimized provision of its services. If consent to the
              storage of cookies and comparable recognition technologies has been requested, the processing takes place
              processing is carried out exclusively on the basis of this consent (Art. 6 para. 1 lit. a GDPR and § 25 para. 1
              TDDDG); consent can be revoked at any time.
            </p>
            <p>
              You can set your browser so that you are informed about the setting of cookies and
              allow cookies only in individual cases, exclude the acceptance of cookies for certain cases or in general
              and activate the automatic deletion of cookies when closing the browser. With the
              deactivating cookies may limit the functionality of this website.
            </p>
            <p>
              You can find out which cookies and services are used on this website in this
              privacy policy.
            </p>

            <h3>Contact form</h3>
            <p>
              If you send us inquiries via the contact form, your details from the enquiry form
              form, including the contact details you provide there, for the purpose of processing the request
              and in the event of follow-up questions. We will not pass on this data without your
              consent.
            </p>
            <p>
              This data is processed on the basis of Art. 6 para. 1 lit. b GDPR, provided that your request is related to
              related to the fulfillment of a contract or for the implementation of pre-contractual measures
              is required. In all other cases, the processing is based on our legitimate interest in the effective
              effective processing of the requests addressed to us (Art. 6 para. 1 lit. f GDPR) or on your
              consent (Art. 6 para. 1 lit. a GDPR) if this has been requested; consent can be revoked at any time.
              revocable at any time.
            </p>
            <p>
              We will retain the data you provide on the contact form until you request its deletion, revoke your consent to its
              request deletion, revoke your consent to storage or the purpose for data storage no longer applies
              (e.g. after your request has been processed). Mandatory statutory provisions - in particular
              in particular retention periods - remain unaffected.
            </p>

            <h3>Request by e-mail, telephone or fax</h3>
            <p>
              If you contact us by e-mail, telephone or fax, your request, including all personal data resulting from it
              personal data (name, inquiry) for the purpose of processing your request.
              stored and processed by us. We will not pass on this data without your consent.
            </p>
            <p>
              This data is processed on the basis of Art. 6 para. 1 lit. b GDPR, provided that your request is related to
              related to the fulfillment of a contract or for the implementation of pre-contractual measures
              is required. In all other cases, the processing is based on our legitimate interest in the effective
              effective processing of the requests addressed to us (Art. 6 para. 1 lit. f GDPR) or on your
              consent (Art. 6 ```tsx
              para. 1 lit. a GDPR) if this has been requested; consent can be withdrawn at any time.
            </p>
            <p>
              The data you send to us via contact requests will remain with us until you request us to delete it, revoke your
              request deletion, revoke your consent to storage or the purpose for data storage no longer applies
              (e.g. after your request has been processed). Mandatory statutory provisions -
              in particular statutory retention periods - remain unaffected.
            </p>
          </section>

          <section>
            <h2>5. Newsletter</h2>
            <h3>Newsletter data</h3>
            <p>
              If you would like to receive the newsletter offered on the website, we require an e-mail address from you as well as
              address as well as information that allows us to verify that you are the owner of the e-mail address
              e-mail address provided and that you agree to receive the newsletter. Further
              data is not collected or is only collected on a voluntary basis. We use this data exclusively for
              for sending the requested information and do not pass it on to third parties.
            </p>
            <p>
              The processing of the data entered in the newsletter registration form takes place exclusively on the basis of your
              on the basis of your consent (Art. 6 para. 1 lit. a GDPR). You can revoke your consent to the storage of the
              data, the e-mail address and its use for sending the newsletter can be revoked at any time
              via the “Unsubscribe” link in the newsletter. The legality of the data processing operations
              data processing operations already carried out remains unaffected by the revocation.
            </p>
            <p>
              The data you provide us with for the purpose of subscribing to the newsletter will be stored by us or the newsletter service provider until you
              newsletter with us or the newsletter service provider and will be deleted from the newsletter distribution list after you
              newsletter or deleted from the newsletter distribution list after the purpose has ceased to apply. We
              reserve the right to delete e-mail addresses from our newsletter distribution list at our own discretion within the scope of our
              our legitimate interest in accordance with Art. 6 para. 1 lit. f GDPR.
            </p>
            <p>
              Data stored by us for other purposes remains unaffected by this.
            </p>
            <p>
              After you unsubscribe from the newsletter distribution list, your e-mail address will be stored by us or the newsletter service provider
              newsletter service provider in a blacklist, if this is necessary to prevent future mailings.
              mailings is necessary. The data from the blacklist will only be used for this purpose and will not be merged with
              merged with other data. This serves both your interest and our interest in
              compliance with the legal requirements when sending newsletters (legitimate interest within the meaning of
              Art. 6 para. 1 lit. f GDPR). Storage in the blacklist is not limited in time. You can object to the
              storage if your interests outweigh our legitimate interest.
            </p>
          </section>

          <section>
            <h2>6. Plugins und Tools</h2>
            <h3>Google Fonts</h3>
            <p>
              This site uses so-called Google Fonts, which are provided by Google, for the uniform display of fonts.
              are provided by Google. When you call up a page, your browser loads the required fonts into your browser cache,
              to display texts and fonts correctly.
            </p>
            <p>
              For this purpose, the browser you are using must connect to Google's servers.
              servers. This informs Google that this website has been accessed via your IP address.
              has been accessed. The use of Google Fonts is based on Art. 6 para. 1 lit. f GDPR. The
              website operator has a legitimate interest in the uniform presentation of the typeface on its website.
              website. If a corresponding consent has been requested, the processing takes place exclusively
              on the basis of Art. 6 para. 1 lit. a GDPR and § 25 para. 1 TDDDG, insofar as the consent allows the
              storage of cookies or access to information in the user's terminal device (e.g. device
              fingerprinting) within the meaning of the TDDDG. Consent can be revoked at any time.
            </p>
            <p>
              If your browser does not support Google Fonts, a standard font will be used by your computer.
            </p>
            <p>
              Further information on Google Fonts can be found at
              https://developers.google.com/fonts/faq and in Google's privacy policy:
              https://policies.google.com/privacy?hl=en.
            </p>
            <p>
              The company is certified in accordance with the “EU-US Data Privacy Framework” (DPF). The
              DPF is an agreement between the European Union and the USA that is intended to ensure compliance with
              European data protection standards for data processing in the USA. Every company certified under
              DPF-certified company undertakes to comply with these data protection standards. Further
              information on this can be obtained from the provider at the following link:
              https://www.dataprivacyframework.gov/participant/5780.
            </p>
          </section>

          <p className="text-sm text-gray-600 mt-8">
            Source: https://www.e-recht24.de
          </p>
        </div>
      ) : (
        <div className="prose prose-lg max-w-none">
          {/* German privacy policy content - keeping all the existing content */}
          <h1>Datenschutzerklärung</h1>
          
          <section>
            <h2>1. Datenschutz auf einen Blick</h2>
            <h3>Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen
              Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>

            <h3>Datenerfassung auf dieser Website</h3>
            <h4>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
            <p>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
              können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
            </p>

            <h4>Wie erfassen wir Ihre Daten?</h4>
            <p>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um
              Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p>
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme
              erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit
              des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>

            <h4>Wofür nutzen wir Ihre Daten?</h4>
            <p>
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere
              Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
              geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote,
              Bestellungen oder sonstige Auftragsanfragen verarbeitet.
            </p>

            <h4>Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
            <p>
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer
              gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder
              Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
              können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
              bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
            <p>
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
            </p>

            <h4>Analyse-Tools und Tools von Drittanbietern</h4>
            <p>
              Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor
              allem mit sogenannten Analyseprogrammen.
            </p>
            <p>
              Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden
              Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2>2. Hosting</h2>
            <h3>Externes Hosting</h3>
            <p>
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden,
              werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei kann es sich v. a. um IP-Adressen,
              Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe
              und sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
            <p>
              Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und
              bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten
              Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
            <p>
              Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf
              Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
              von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting) im
              Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p>
              Unser(e) Hoster wird bzw. werden Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner
              Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.
            </p>
            <p>
              Wir setzen folgende(n) Hoster ein:<br />
              Netlify Inc.<br />
              Inc., 44 Montgomery Street, Suite 300<br />
              San Francisco, California 94104,<br />
              USA (hereinafter "Netlify")
            </p>

            <h4>Auftragsverarbeitung</h4>
            <p>
              Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes
              geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der
              gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren
              Weisungen und unter Einhaltung der DSGVO verarbeitet.
            </p>
          </section>

          <section>
            <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
            <h3>Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie
              dieser Datenschutzerklärung.
            </p>
            <p>
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
              Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende
              Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie
              und zu welchem Zweck das geschieht.
            </p>
            <p>
              Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail)
              Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
              möglich.
            </p>

            <h3>Hinweis zur verantwortlichen Stelle</h3>
            <p>
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p>
              Simon Stürzenhofecker<br />
              Birkenstrasse 1<br />
              91249 Weigendorf<br />
              Deutschland
            </p>
            <p>
              Telefon: +49 (0) 176 24938417<br />
              E-Mail: info@simons-marketing-solutions.com
            </p>
            <p>
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über
              die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.)
              entscheidet.
            </p>

            <h3>Speicherdauer</h3>
            <p>
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben
              Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein
              berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen,
              werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
              personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im
              letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
            </p>

            <h3>Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website</h3>
            <p>
              Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf
              Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien
              nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung in die Übertragung
              personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf Grundlage von Art.
              49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf Informationen in
              Ihr Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich
              auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur
              Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten wir Ihre
              Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese
              zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO.
              Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f
              DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden
              Absätzen dieser Datenschutzerklärung informiert.
            </p>

            <h3>Empfänger von personenbezogenen Daten</h3>
            <p>
              Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei
              ist teilweise auch eine Übermittlung von personenbezogenen Daten an diese externen Stellen erforderlich.
              Wir geben personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer
              Vertragserfüllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z. B. Weitergabe von Daten
              an Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe
              haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
              Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden nur auf Grundlage eines gültigen
              Vertrags über Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über
              gemeinsame Verarbeitung geschlossen.
            </p>

            <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p>
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine
              bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
              Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>

            <h3>Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)</h3>
            <p>
              WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO
              ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN
              SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN
              WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES
              PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,
              ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN,
              WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES
              SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG
              NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE
              VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON
              RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
            </p>
            <p>
              WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN,
              SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE
              BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG
              EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN
              VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN
              ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH
              NACH ART. 21 ABS. 2 DSGVO).
            </p>

            <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
            <p>
              Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer
              Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
              oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger
              verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
            </p>

            <h3>Recht auf Datenübertragbarkeit</h3>
            <p>
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
              automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format
              aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
              verlangen, erfolgt dies nur, soweit es technisch machbar ist.
            </p>

            <h3>Auskunft, Berichtigung und Löschung</h3>
            <p>
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche
              Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den
              Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie
              zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
            </p>

            <h3>Recht auf Einschränkung der Verarbeitung</h3>
            <p>
              Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
              folgenden Fällen:
            </p>
            <ul>
              <li>
                Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir
                in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die
                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              </li>
              <li>
                Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie
                statt der Löschung die Einschränkung der Datenverarbeitung verlangen.
              </li>
              <li>
                Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
                Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der
                Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              </li>
              <li>
                Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen
                Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
                überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten
                zu verlangen.
              </li>
            </ul>
            <p>
              Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von
              ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder
              Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder
              juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder
              eines Mitgliedstaats verarbeitet werden.
            </p>

            <h3>SSL- bzw. TLS-Verschlüsselung</h3>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum
              Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-
              Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von
              „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
            <p>
              Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht
              von Dritten mitgelesen werden.
            </p>

            <h3>Widerspruch gegen Werbe-E-Mails</h3>
            <p>
              Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von
              nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die
              Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von
              Werbeinformationen, etwa durch Spam-E-Mails, vor.
            </p>
          </section>

          <section>
            <h2>4. Datenerfassung auf dieser Website</h2>
            <h3>Cookies</h3>
            <p>
              Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete und richten auf
              Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies
              werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät
              gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
            </p>
            <p>
              Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party-
              Cookies). Third-Party-Cookies ermöglichen die Einbindung bestimmter Dienstleistungen von
              Drittunternehmen innerhalb von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
            </p>
            <p>
              Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte
              Webseitenfunktionen ohne diese nicht funktionieren würden (z. B. die Warenkorbfunktion oder die Anzeige
              von Videos). Andere Cookies können zur Auswertung des Nutzerverhaltens oder zu Werbezwecken
              verwendet werden.
            </p>
            <p>
              Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs, zur Bereitstellung
              bestimmter, von Ihnen erwünschter Funktionen (z. B. für die Warenkorbfunktion) oder zur Optimierung der
              Website (z. B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf
              Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird.
              Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur
              technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur
              Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die
              Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
              TDDDG); die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p>
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und
              Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen
              sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der
              Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.
            </p>
            <p>
              Welche Cookies und Dienste auf dieser Website eingesetzt werden, können Sie dieser
              Datenschutzerklärung entnehmen.
            </p>

            <h3>Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
              Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
              und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre
              Einwilligung weiter.
            </p>
            <p>
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit
              der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der
              effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
              Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit
              widerrufbar.
            </p>
            <p>
              Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung
              auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt
              (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen –
              insbesondere Aufbewahrungsfristen – bleiben unberührt.
            </p>

            <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>
            <p>
              Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus
              hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens
              bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p>
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit
              der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der
              effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
              Einwilligung (Art. 6  ```tsx
              Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p>
              Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
              auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt
              (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen –
              insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.
            </p>
          </section>

          <section>
            <h2>5. Newsletter</h2>
            <h3>Newsletterdaten</h3>
            <p>
              Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine E-Mail-
              Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der
              angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind. Weitere
              Daten werden nicht bzw. nur auf freiwilliger Basis erhoben. Diese Daten verwenden wir ausschließlich für
              den Versand der angeforderten Informationen und geben diese nicht an Dritte weiter.
            </p>
            <p>
              Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen Daten erfolgt ausschließlich auf
              Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der
              Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des Newsletters können Sie jederzeit
              widerrufen, etwa über den „Austragen"-Link im Newsletter. Die Rechtmäßigkeit der bereits erfolgten
              Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
            </p>
            <p>
              Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von uns bis zu Ihrer
              Austragung aus dem Newsletter bei uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der
              Abbestellung des Newsletters oder nach Zweckfortfall aus der Newsletterverteilerliste gelöscht. Wir
              behalten uns vor, E-Mail-Adressen aus unserem Newsletterverteiler nach eigenem Ermessen im Rahmen
              unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO zu löschen oder zu sperren.
            </p>
            <p>
              Daten, die zu anderen Zwecken bei uns gespeichert wurden, bleiben hiervon unberührt.
            </p>
            <p>
              Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei uns bzw. dem
              Newsletterdiensteanbieter ggf. in einer Blacklist gespeichert, sofern dies zur Verhinderung künftiger
              Mailings erforderlich ist. Die Daten aus der Blacklist werden nur für diesen Zweck verwendet und nicht mit
              anderen Daten zusammengeführt. Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der
              Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern (berechtigtes Interesse im Sinne des
              Art. 6 Abs. 1 lit. f DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht befristet. Sie können der
              Speicherung widersprechen, sofern Ihre Interessen unser berechtigtes Interesse überwiegen.
            </p>
          </section>

          <section>
            <h2>6. Plugins und Tools</h2>
            <h3>Google Fonts</h3>
            <p>
              Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von Google
              bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Fonts in ihren Browsercache,
              um Texte und Schriftarten korrekt anzuzeigen.
            </p>
            <p>
              Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google
              aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse diese Website
              aufgerufen wurde. Die Nutzung von Google Fonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
              Websitebetreiber hat ein berechtigtes Interesse an der einheitlichen Darstellung des Schriftbildes auf seiner
              Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich
              auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die
              Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B. Device-
              Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p>
              Wenn Ihr Browser Google Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.
            </p>
            <p>
              Weitere Informationen zu Google Fonts finden Sie unter
              https://developers.google.com/fonts/faq und in der Datenschutzerklärung von Google:
              https://policies.google.com/privacy?hl=de.
            </p>
            <p>
              Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy Framework" (DPF). Der
              DPF ist ein Übereinkommen zwischen der Europäischen Union und den USA, der die Einhaltung
              europäischer Datenschutzstandards bei Datenverarbeitungen in den USA gewährleisten soll. Jedes nach
              dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere
              Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:
              https://www.dataprivacyframework.gov/participant/5780.
            </p>
          </section>

          <p className="text-sm text-gray-600 mt-8">
            Quelle: https://www.e-recht24.de
          </p>
        </div>
      )}
    </div>
  );
};

export default PrivacyContent;
